import mutations from '../mutations';
import api from '../../api';

export default {
  namespaced: true,
  state: {
    loading: false
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getListDivision({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spendingDynamic
        .getListDivision(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getDetailReport({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spendingDynamic
        .getDetailReport(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getLevel({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spendingDynamic
        .getLevel(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getIO({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spendingDynamic
        .getIO(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    submitIO({ commit }, payload) {
      commit(mutations.LOADING);
      return api.spendingDynamic
        .submitIO(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getFiltered({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spendingDynamic
        .getFiltered(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getConsolidatedReport({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spendingDynamic
        .getConsolidatedReport(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    getSummaryConsolidate({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spendingDynamic
        .getSummaryConsolidate(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    getBackup({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.spendingDynamic
        .getBackup(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    deleteBackup({ commit }, id) {
      commit(mutations.LOADING);
      return api.spendingDynamic
        .deleteBackup(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    }
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    user: state => state.user,
    token: state => state.token,
    isLoading: state => state.loading,
    error: state => {
      if (state.error && state.error.response) {
        return state.error.response.data;
      }
      return state.error;
    }
  }
};
